<template>
  <div class="w-100">
       <v-toolbar flat class="sub-toolbar d-flex">
      <!-- Esc salir-->
      <!--<img class='btn-footer-izq pointer' src='@/assets/images/Btn-ESC.gif' @click='salir'>-->
      <v-btn flat class="primary-color back mr-auto" @click='salir'><v-icon class="mr-2">arrow_back</v-icon>{{ $t('lang.comun.salir') }}</v-btn> 
      <!-- Guardar Datos Personales-->
      <!--<img class='btn-footer-der pointer' src='@/assets/images/Btn-FIN.gif' @click='guardarDatosPersona'>
      <v-btn flat class="primary-color"><v-icon class="mr-1">save</v-icon>{{ msj.grabardatos }}</v-btn>-->
      <!-- Guardar Foto  -->
    </v-toolbar>
    <div class="margin-top pl-4 pr-5 align-items-center d-flex w-100 px-3">
      <PersonasTabFoto :personaParam='selectedPersona' :tabSeleccionado='tabSeleccionado' :clickGuardarFotoPersona='event.clickGuardarFotoPersona' :clickBorrarFotoPersona='event.clickBorrarFotoPersona'/>
      <PersonasTabDatosPersonales :personaParam='selectedPersona' :tabSeleccionado='tabSeleccionado' :clickGuardarDatosPersona='event.clickGuardarDatosPersona'/>
    </div>
    <v-btn fab large dark class="right orange guardar mr-5 mb-0" >
      <v-icon class="" @click='guardarDatosPersona'>save</v-icon>
      <!--{{ msj.grabardatos }}-->
    </v-btn>
    <!-- TABS -->
    <div class='w-100 d-flex'>
        <div v-if="selectedPersona">
          <vue-tabs @tab-change='handleTabChange' v-model='tabNombre'>
            <!-- Tab.PersonasTabVacaciones -->
            <v-tab :title='tabnombres.tabvacaciones' >
              <PersonasTabVacaciones :personaParam='selectedPersona' :tabSeleccionado='tabSeleccionado' />
            </v-tab>
            <!-- Tab.PersonasTabFichajes -->
            <v-tab :title='tabnombres.tabfichajes' >
              <PersonasTabFichajes :personaParam='selectedPersona' :tabSeleccionado='tabSeleccionado' />
            </v-tab>
            <!-- Tab.PersonasTabJornada -->
            <v-tab :title='tabnombres.tabjornada' v-if="false">
              <PersonasTabJornada :personaParam='selectedPersona' :tabSeleccionado='tabSeleccionado' />
            </v-tab>
            <v-tab title='Permisos' v-if="$store.getters.isAdminSYS4">
              <PersonasTabACL :personaParam='selectedPersona' :tabSeleccionado='tabSeleccionado'/>
            </v-tab>
          </vue-tabs>
        </div>
       
    </div>
    <!-- FIN. TABS -->
    <!-- Footer de botones 
    <div id='footer'>-->
      <!-- Esc salir
      <img class='btn-footer-izq pointer' src='@/assets/images/Btn-ESC.gif' @click='salir'>
      <label class='txt-footer-izq'>{{ $t('lang.comun.salir') }}</label> -->
      <!-- Guardar Datos Personales
      <img class='btn-footer-der pointer' src='@/assets/images/Btn-FIN.gif' @click='guardarDatosPersona'>
      <label class='txt-footer-der'>{{ msj.grabardatos }}</label>-->
      <!-- Guardar Foto  
      <img class='btn-footer-der pointer' src='@/assets/images/Btn_F2.gif' @click='guardarFotoPersona'>
      <label class='txt-footer-der'>{{ msj.grabarfoto }}</label>-->
      <!-- Borrar Foto 
      <img class='btn-footer-der pointer' src='@/assets/images/Btn-SUPR.gif' @click='borrarFotoPersona'>
      <label class='txt-footer-der'>{{ msj.borrarfoto }}</label>
    </div>-->
    <!-- FIN. Footer de botones -->
  </div>
</template>
<script>
import { PersonaApiService } from '@/api/PersonaApiService'
import { VueTabs, VTab } from 'vue-nav-tabs/dist/vue-tabs.js'
import PersonasTabDatosPersonales from '@/views/PersonasTabDatosPersonales'
import PersonasTabACL from '@/views/PersonasTabACL'
import PersonasTabFoto from '@/views/PersonasTabFoto'
import PersonasTabVacaciones from '@/views/PersonasTabVacaciones'
import PersonasTabFichajes from '@/views/PersonasTabFichajes'
import PersonasTabJornada from '@/views/PersonasTabJornada'


import { Util } from '@/api/Util'

const personaApiService = new PersonaApiService()
const util = new Util()

export default {
  data () {
    return {
      personaLogin: {},
      selectedPersona: null,
      urlImagen: process.env.VUE_APP_URL_API_PERSONA + 'getPersonaFoto/',
      personaAdd: 0,
      opUid: this.$store.getters.getOpuid,
      userid: this.$route.query.userid,
      useruid: this.$route.query.useruid,
      tabSeleccionado: 0,
      tabNewtab: '',
      tabOldtab: '',
      tabNombre: '',
      msj: {
        quitarpersona: this.$t('lang.msjconfirm.quitarpersona'),
        continuarsinguardar: this.$t('lang.msjconfirm.continuarsinguardar'),
        grabardatos: this.$t('lang.comun.grabardatos'),
        grabarfoto: this.$t('lang.comun.grabarfoto'),
        borrarfoto: this.$t('lang.comun.borrarfoto'),
        totalper: this.$t('lang.personas.totalper'),
        addpersona: this.$t('lang.personas.addpersona'),
        quitar: this.$t('lang.comun.quitar'),
        anhadir: this.$t('lang.comun.anhadir'),
        siguiente: this.$t('lang.comun.siguiente'),
        anterior: this.$t('lang.comun.anterior'),
        grabarfestivo: this.$t('lang.comun.grabarfestivo'),
        borrarfestivo: this.$t('lang.comun.borrarfestivo')
      },
      tabnombres: {
        tabdatos: this.$t('lang.tabs.tabdatos'),
        tabfoto: this.$t('lang.tabs.tabfoto'),
        tabvacaciones: this.$t('lang.tabs.tabvacaciones'),
        tabfichajes: this.$t('lang.tabs.tabfichajes'),
        tabfichajesdetalle: this.$t('lang.tabs.tabfichajesdetalle'),
        tabjornada: this.$t('lang.tabs.tabjornada'),
        tabmantcalenlab: this.$t('lang.tabs.tabmantcalenlab'),
        tabcrear: this.$t('lang.tabs.tabcrear')
      },
      shift: false,
      ctrl: false,
      event: {
        clickCrearPersona: 0,
        clickGuardarDatosPersona: 0,
        clickGuardarFotoPersona: 0,
        clickBorrarFotoPersona: 0,
        clickGuardarCalenlab: 0,
        clickBorrarCalenlab: 0
      },
      lang: this.$route.query.lang,
      perMant: true
    }
  },
  props: {
    empleadouid: String
  },
  components: {
    VueTabs,
    VTab,
    PersonasTabDatosPersonales,
    PersonasTabFoto,
    PersonasTabVacaciones,
    PersonasTabFichajes,
    PersonasTabJornada,
    PersonasTabACL
  },
  created () {
    this.mountListenerTeclas()
    // Guardamos el usuario en sesion
    if (this.userid) {
      sessionStorage.setItem('userid', this.userid)
    }
    if (this.empleadouid) {
      this.useruid = this.empleadouid
      sessionStorage.setItem('useruid', this.useruid)
      this.findPersona()
    } else if (sessionStorage.getItem('useruid')) {
        this.useruid = sessionStorage.getItem('useruid')
        this.findPersona()
    }
    if (this.opUid) {
      sessionStorage.setItem('opUid', this.opUid)
    }
    if (this.lang) {
      sessionStorage.setItem('lang', this.lang)
    } else { // por defecto castellano
      sessionStorage.setItem('lang', 'es')
    }
  },
  computed: {
    personasMostrar: function () {
      var result = []
      if (this.grupoMostrar === 1) {
        for (let i = 0; i < this.personas.length && i < this.totalMostrar; i++) {
          result.push(this.personas[i])
        }
      } else {
        var indice = (this.grupoMostrar - 1) * this.totalMostrar
        for (let i = indice; i < this.personas.length && i < (this.totalMostrar * this.grupoMostrar); i++) {
          result.push(this.personas[i])
        }
      }
      return result
    },
    isPersonaAddSelected: function () {
      if (this.personaAdd === 0) {
        return false
      } else {
        return true
      }
    },
    isPersonaRemSelected: function () {
      if (this.selectedPersona) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    mountListenerTeclas () {
      // TODO: configurar las teclas
      window.addEventListener('keydown', (e) => {
        if (e.keyCode === 16) { // Shift
          this.shift = true
        }
        if (e.keyCode === 17) { // Ctrl
          this.ctrl = true
        }
      })
      window.addEventListener('keyup', (e) => {
        if (e.keyCode === 34) {
          if (this.shift) { // (SHIFT + Av Pag) Grupo siguiente
            this.grupoSiguiente()
          } else { // (Av Pag) Siguiente persona
            if (this.selectedCard !== -1 && (this.selectedCard + 1 < this.personasMostrar.length)) {
              this.selectCard(this.personasMostrar[this.selectedCard + 1], this.selectedCard + 1)
            }
          }
        } else if (e.keyCode === 33) {
          if (this.shift) { // (SHIFT + Re Pag) Grupo anterior
            this.grupoAnterior()
          } else { // (Re Pag) Anterior persona
            if (this.selectedCard !== -1 && (this.selectedCard - 1 >= 0)) {
              this.selectCard(this.personasMostrar[this.selectedCard - 1], this.selectedCard - 1)
            }
          }
        } else if (e.keyCode === 16) { // SHIFT
          this.shift = false
        } else if (e.keyCode === 17) { // CTRL
          this.ctrl = false
        } else if (e.keyCode === 65) { // Tab Datos personales CTRL + SHIFT + A
          if (this.ctrl && this.shift) {
            this.tabNombre = this.tabnombres.tabdatos
          }
        } else if (e.keyCode === 83) { // Tab Foto CTRL + SHIFT + S
          if (this.ctrl && this.shift) {
            this.tabNombre = this.tabnombres.tabfoto
          }
        } else if (e.keyCode === 188) { // Tab Foto CTRL + (),)
          if (this.ctrl) {
            this.removePersona()
          }
        } else if (e.keyCode === 190) { // Tab Foto CTRL + (.)
          if (this.ctrl) {
            this.addPersona()
          }
        } else if (e.keyCode === 27) { // ESC
          this.salir()
        } else if (e.keyCode === 35) { // FIN
          this.guardarDatosPersona()
        } 
      })
    },
    handleTabChange (tabIndex, newTab, oldTab) {
      switch (tabIndex) {
        case 0:
          this.tabSeleccionado = 0
          this.tabNewtab = newTab
          this.tabOldtab = oldTab
          break
        case 1:
          this.tabSeleccionado = 1
          this.tabNewtab = newTab
          this.tabOldtab = oldTab
          break
        case 2:
          this.tabSeleccionado = 2
          this.tabNewtab = newTab
          this.tabOldtab = oldTab
          break
        case 3:
          this.tabSeleccionado = 3
          this.tabNewtab = newTab
          this.tabOldtab = oldTab
          break
        case 4:
          this.tabSeleccionado = 4
          this.tabNewtab = newTab
          this.tabOldtab = oldTab
          break
        case 5:
          this.tabSeleccionado = 5
          this.tabNewtab = newTab
          this.tabOldtab = oldTab
          break
        case 6:
          this.tabSeleccionado = 6
          this.tabNewtab = newTab
          this.tabOldtab = oldTab
          break
        case 7:
          this.tabSeleccionado = 7
          this.tabNewtab = newTab
          this.tabOldtab = oldTab
          break
        default:
          break
      }
    },
    getPersonaById (personaid) {
      personaApiService.getPersonaById(personaid)
        .then(data => {
          // util.mostrarEnConsola('Personas - getPersonaById', data.length, 'OK')
          this.personas = data
        })
        .catch(error => {
          util.mostrarEnConsola('Personas - getPersonaById', error, 'ERROR')
        })
    },
    findPersona () {
      if (this.useruid) {
        personaApiService.findPersona({mspersonauid: this.useruid})
          .then(data => {
            if (data.mspersonaid) {
              // util.mostrarEnConsola('Personas - findPersona', data.mspersonaid, 'OK')
              this.selectedPersona = data
              // sessionStorage.setItem('persona', this.selectedPersona)
              // sessionStorage.setItem('userid', this.selectedPersona.mspersonaid)
            }
          })
          .catch(error => {
            util.mostrarEnConsola('Personas - findPersona', error, 'ERROR')
          })
      }
    },
    getImgUrl: function (mspersonauid) {
      return this.urlImagen + mspersonauid + '?' + Math.random()
    },
    salir () {
      this.$router.push('/Personal')
    },
    guardarDatosPersona () {
      this.event.clickGuardarDatosPersona++
    },
    guardarFotoPersona () {
      this.event.clickGuardarFotoPersona++
    },
    borrarFotoPersona () {
      this.event.clickBorrarFotoPersona++
    },
    guardarCalenlab () {
      this.event.clickGuardarCalenlab++
    },
    borrarCalenlab () {
      this.event.clickBorrarCalenlab++
    },
    guardarPersonaSesion (persona) {
      if (persona) {
        sessionStorage.setItem('personaAux', JSON.stringify(persona))
      }
    }
  }
}
</script>
